interface IconProps {
  className?: string;
}

const strokeProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export function SunIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
    </svg>
  );
}

export function MoonIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <path d="M20 14.5A8.5 8.5 0 119.5 4 6.5 6.5 0 0020 14.5z" />
    </svg>
  );
}

export function ShareIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <path d="M12 15V4" />
      <path d="M7.5 8.5L12 4l4.5 4.5" />
      <rect x="4.5" y="12.5" width="15" height="7" rx="1.5" />
    </svg>
  );
}

export function SearchIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="M20 20l-4.3-4.3" />
    </svg>
  );
}

export function CloseIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}

export function CompassIcon({ className }: IconProps) {
  return (
    <svg {...strokeProps} className={className}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 4v3M12 17v3M4 12h3M17 12h3" />
      <path d="M12 7l2.5 4.5L12 16l-2.5-4.5z" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function MedalIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor">
      <circle cx="12" cy="8.5" r="6" />
      <path d="M8.2 13.5L6 21l6-3.2 6 3.2-2.2-7.5-1.4 1.1L12 16l-2.4-1.1z" />
      <path d="M12 5l1.1 2.2 2.4.35-1.75 1.7.4 2.4L12 10.5l-2.15 1.15.4-2.4L8.5 7.55l2.4-.35z" fill="#fff" fillOpacity="0.9" />
    </svg>
  );
}
